import { React, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Hooks do React Router
import projetosData from "../data/projetosGerais.json"; // JSON com todos os projetos
import Card from "../components/Card/Card"; // Componente de exibição de projeto resumido

function Detalhes() {

  const containerRef = useRef(null);


  // 🔹 Pega o id do projeto que está na URL
  const { id } = useParams();

  // 🔹 Cria função para navegar entre páginas
  const navigate = useNavigate();

  // 🔹 Converte o id da URL para número
  const projetoId = Number(id);

  // 🔹 Busca o projeto correspondente no JSON
  const projeto = projetosData.find((p) => p.id === projetoId);

  // 🔹 Força scroll para o topo ao abrir a página de detalhes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔹 Se o projeto não existir, mostra mensagem de erro e botão de voltar
  if (!projeto) {
    return (
      <div style={{ padding: 24 }}>
        <p>Projeto não encontrado.</p>
        <button onClick={() => navigate(-1)}>Voltar</button>
      </div>
    );
  }

  // 🔹 Extrai informações de mídia do projeto
const { apresentacao } = projeto;

// 🔹 Pega a primeira tag do projeto (usada para sugerir projetos relacionados)
const mainTag = projeto.tags && projeto.tags[0];

const relacionado = projetosData
  .filter(function (p) {

    if (p.id === projetoId) {
      return false;
    }

    if (!p.tags) {
      return false;
    }

    if (!mainTag) {
      return false;
    }

    return p.tags.includes(mainTag);
  })
  .slice(0, 4);

  return (
    <main className="detalhes">

      {/* 🔹 Fundo escuro (cenário da página) */}
      {/* 🔹 Seção superior preta */}
      <section className="detalhes-topo">
      </section>

      {/* 🔹 Seção branca (conteúdo) */}
      <section className="detalhes-conteudo">

        <div className="detalhes-container">

          {/* 🔹 Área branca (conteúdo principal) */}

          {/* 🔹 Seção de mídia do projeto */}
          <div className="detalhe-media" >
            {/* Imagem */}
            {apresentacao.tipo === "imagem" && (
              <img
                src={apresentacao.arquivo}
                alt={projeto.titulo}
                style={{ width: "100%", maxHeight: 520, objectFit: "cover" }}
              />
            )}

            {/* Vídeo */}
            {apresentacao.tipo === "video" && (
              <video controls style={{ width: "100%", maxHeight: 520 }}>
                <source src={apresentacao.arquivo} type="video/mp4" />
                Seu navegador não suporta o elemento de vídeo.
              </video>
            )}

            {/* Vídeo do YouTube */}
            {apresentacao.tipo === "youtube" && (
              <iframe
                title={projeto.titulo}
                src={apresentacao.url}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ width: "100%", height: 520 }}
              />
            )}
          </div>

          <article className="detalhe-card">

            {/* 🔹 Linha superior: título + tags */}
            <div className="detalhe-cabecalho">

              <h1>{projeto.titulo}</h1>

              <div className="detalhe-tags">
                {projeto.tags.map((t) => (
                  <span key={t} className="card-tag">
                    {t}
                  </span>
                ))}
              </div>

            </div>

            {/* 🔹 Descrição ou informação adicional */}
            <div className="detalhe-info">
              <p>{projeto.info || projeto.descricao}</p>
            </div>

            {/* 🔹 Links úteis */}
            <div className="detalhe-links">
              {apresentacao.tipo === "video" && apresentacao.arquivo && (
                <a
                  href={apresentacao.arquivo}
                  download
                  className="detalhe-botao"
                >
                  ⬇ Baixar vídeo
                </a>
              )}

              {apresentacao.tipo === "youtube" && apresentacao.url && (
                <a
                  href={apresentacao.url.replace("/embed/", "/watch?v=")}
                  target="_blank"
                  rel="noreferrer"
                  className="detalhe-botao"
                >
                  ▶ Ver no YouTube
                </a>
              )}
            </div>

          </article>

        </div>

        {/* 🔹 Se houver projetos relacionados, mostra uma seção com cards */}
        {relacionado.length > 0 && (
          <section className="relacionados">
            <div className="relacionados-container">

              <h2 className="relacionados-titulo">
                Projetos relacionados
              </h2>

              <div className="carousel-wrapper">
                <button
                  className="carousel-btn left"
                  onClick={function () {
                    if (containerRef.current) {
                      containerRef.current.scrollBy({ left: -300, behavior: "smooth" });
                    }
                  }}
                >
                  ❮
                </button>

                <div ref={containerRef} className="cards-container">
                  {relacionado.map(function (p) {
                    return (
                      <Card
                        key={p.id}
                        projeto={p}
                        onClick={function (id) {
                          navigate(`/projeto/${id}`);
                        }}
                      />
                    );
                  })}
                </div>

                <button
                  className="carousel-btn right"
                  onClick={function () {
                    if (containerRef.current) {
                      containerRef.current.scrollBy({ left: 300, behavior: "smooth" });
                    }
                  }}
                >
                  ❯
                </button>
              </div>

            </div>
          </section>
        )}

      </section>

    </main >
  );
}

export default Detalhes;
